import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const ExportReportModal = ({ show, handleClose, template, reportData, onExport }) => {
  const [selectedFormat, setSelectedFormat] = useState("csv");
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    if (!reportData || reportData.length === 0) {
      alert("No data to export. Please run a report first.");
      return;
    }

    setExporting(true);
    try {
      await onExport(selectedFormat, template, reportData);
      handleClose();
    } catch (error) {
      console.error("Export failed:", error);
      alert("Export failed. Please try again.");
    } finally {
      setExporting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="md"
    >
      <div style={{ minHeight: "150px" }}>
        <Modal.Header
          style={{ borderBottom: "0px" }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Export Report
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0 m-t-5 m-l-5 m-r-5 m-b-5" style={{ minHeight: "120px" }}>
          <div className="custom-tab">
            <div className="row mx-0 align-items-center" style={{ marginBottom: "10px" }}>
              <div className="col-md-12 p-0">
                <div
                  className="m-b-5"
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "var(--primary)",
                  }}
                >
                  Select Export Format
                </div>

                {/* Format Selection */}
                <div className="d-flex flex-column" style={{ gap: "10px" }}>
                  {/* CSV Option */}
                  <label
                    className="d-flex align-items-center"
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "8px 12px",
                      background: selectedFormat === "csv" ? "var(--primary-10)" : "transparent",
                      border: "1px solid",
                      borderColor:
                        selectedFormat === "csv" ? "var(--primary)" : "var(--primary-25)",
                      borderRadius: "4px",
                      transition: "all 0.15s",
                    }}
                  >
                    <input
                      type="radio"
                      name="exportFormat"
                      value="csv"
                      checked={selectedFormat === "csv"}
                      onChange={(e) => setSelectedFormat(e.target.value)}
                      style={{
                        marginRight: "10px",
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                      }}
                    />
                    <div>
                      <div style={{ fontWeight: "700", color: "var(--primary)" }}>CSV</div>
                      <div
                        style={{ fontSize: "12px", color: "var(--primary-60)", fontWeight: "400" }}
                      >
                        Spreadsheet-compatible format (Excel, Google Sheets)
                      </div>
                    </div>
                  </label>

                  {/* Excel Option */}
                  <label
                    className="d-flex align-items-center"
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "8px 12px",
                      background: selectedFormat === "xlsx" ? "var(--primary-10)" : "transparent",
                      border: "1px solid",
                      borderColor:
                        selectedFormat === "xlsx" ? "var(--primary)" : "var(--primary-25)",
                      borderRadius: "4px",
                      transition: "all 0.15s",
                    }}
                  >
                    <input
                      type="radio"
                      name="exportFormat"
                      value="xlsx"
                      checked={selectedFormat === "xlsx"}
                      onChange={(e) => setSelectedFormat(e.target.value)}
                      style={{
                        marginRight: "10px",
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                      }}
                    />
                    <div>
                      <div style={{ fontWeight: "700", color: "var(--primary)" }}>Excel (XLSX)</div>
                      <div
                        style={{ fontSize: "12px", color: "var(--primary-60)", fontWeight: "400" }}
                      >
                        Native Excel format with formatting
                      </div>
                    </div>
                  </label>

                  {/* PDF Option */}
                  <label
                    className="d-flex align-items-center"
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "8px 12px",
                      background: selectedFormat === "pdf" ? "var(--primary-10)" : "transparent",
                      border: "1px solid",
                      borderColor:
                        selectedFormat === "pdf" ? "var(--primary)" : "var(--primary-25)",
                      borderRadius: "4px",
                      transition: "all 0.15s",
                    }}
                  >
                    <input
                      type="radio"
                      name="exportFormat"
                      value="pdf"
                      checked={selectedFormat === "pdf"}
                      onChange={(e) => setSelectedFormat(e.target.value)}
                      style={{
                        marginRight: "10px",
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                      }}
                    />
                    <div>
                      <div style={{ fontWeight: "700", color: "var(--primary)" }}>PDF</div>
                      <div
                        style={{ fontSize: "12px", color: "var(--primary-60)", fontWeight: "400" }}
                      >
                        Print-ready document format
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="secondary"
            onClick={handleClose}
            disabled={exporting}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            onClick={handleExport}
            disabled={exporting}
          >
            {exporting ? "Exporting..." : `Export as ${selectedFormat.toUpperCase()}`}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default ExportReportModal;
